import styled from "styled-components";
import { SelectDropdown } from "../../Assets/icons";

export const Container = styled.select`
    align-items: center;
    appearance: none; 
    background: url(${SelectDropdown}) right 8px center / 12px no-repeat;
    border: 1px solid #006560;
    border-radius: 5px;
    color: #006560;
    cursor: pointer;
    display: flex;
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    justify-content: center;
    line-height: normal;
    max-width: 350px;
    outline: none;
    padding: 5px;
    text-align: center;

    -moz-appearance: none;
    -webkit-appearance: none; 

    &:hover {
        background-color: #F2F2F2;
        border-color: #33CC99;
    }

    @media (min-width: 720px) {
        align-items: center;
        background-size: 20px;
        color: #006560;
        font-size: 13px;
        justify-content: center;
        padding: 15px 36px 15px 20px;
        text-align: center;

    }
    @media (min-width: 1281px) {
        font-size: 20px;
    }
    @media (orientation: landscape) and (max-width: 1200px){
        align-items: center;
        background-size: 14px;
        border-radius: 5px;
        color: #006560;
        display: flex;
        font-size: 15px;
        justify-content: center;
        max-width: 350px;
        outline: none;
        padding: 5px 6px ;
        text-align: center;
    }
`;

export const StyledOption = styled.option`
    justify-content: center;
    align-items: center;
    color: #006560;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    @media (min-width: 720px) {
        font-weight: 600; 
        text-align: start;
        line-height: 0;
    }
    @media (orientation: landscape) and (max-width: 1200px){
        justify-content: center;
        align-items: center;|
        font-size: 15px;
        font-weight: 700;
    }
    @media (min-width: 1281px) {
        font-size: 15px;
    }
`;